module.exports = __webpack_public_path__ + "media/assets/illustrations/dtc-talent-cloud-c7ab97142593a0bfe3e1e609121f5e68.svg";